import { createFileRoute, redirect } from '@tanstack/react-router';

import { scope2SearchSchema } from '@/features/ghg/pages/GhgScope2CalculationsPage';

export const Route = createFileRoute('/_authenticated/ghg/calculations/scope2')({
  validateSearch: scope2SearchSchema,
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/ghg/emissions', search: { scope: 2 }, replace: true });
  },
});
